import { useEffect, useRef, useState } from 'react';

export const useSearchQuery = (search: string, delay = 300): string => {
	const [searchQuery, setSearchQuery] = useState('');
	const timerRef = useRef<ReturnType<typeof setTimeout>>();

	useEffect(() => {
		timerRef.current = setTimeout(() => setSearchQuery(search), delay);
		return () => clearTimeout(timerRef.current);
	}, [search, delay]);

	return searchQuery;
};
